import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-price-change-item',
  templateUrl: './price-change-item.component.html',
  styleUrls: ['./price-change-item.component.scss']
})
export class PriceChangeItemComponent implements OnInit {

  @Input() public price: number;
  @Input() public percentage: number;
  @Input() public label: number;

  constructor() { }

  ngOnInit(): void {
  }

}
